export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6889.8849d4ba.jpg";